export interface AppConfigState {
  hideHeader: boolean;
  hideMobileDock: boolean;
  hideFooter: boolean;
}

export const initialState: AppConfigState = {
  hideHeader: false,
  hideMobileDock: false,
  hideFooter: false,
};
